<template>
	<div class="animate-pulse">
		<div class="flex flex-row bg-zt-light/35 rounded-t-zt border-[1px] !border-b-[0px] border-zt-light py-2.5 px-2 gap-x-2 overflow-hidden">
			<div class="bg-zt-more opacity-10 min-w-[77px] h-[28px] rounded-zt"></div>
			<div class="bg-zt-more opacity-10 min-w-[72px] h-[28px] rounded-zt"></div>
			<div class="bg-zt-more opacity-10 min-w-[75px] h-[28px] rounded-zt"></div>
			<div class="bg-zt-more opacity-10 min-w-[62px] h-[28px] rounded-zt"></div>
			<div class="bg-zt-more opacity-10 min-w-[111px] h-[28px] rounded-zt"></div>
			<div class="bg-zt-more opacity-10 min-w-[68px] h-[28px] rounded-zt"></div>
			<div class="bg-zt-more opacity-10 min-w-[84px] h-[28px] rounded-zt"></div>
			<div class="bg-zt-more opacity-10 min-w-[122px] h-[28px] rounded-zt"></div>
			<div class="bg-zt-more opacity-10 min-w-[72px] h-[28px] rounded-zt"></div>
			<div class="bg-zt-more opacity-10 min-w-[108px] h-[28px] rounded-zt"></div>
		</div>
		<div class="flex flex-row text-zt-more bg-zt-normal border-[1px] !border-b-[0px] border-zt-light py-2.5 px-2 gap-x-2 overflow-hidden">
			<div class="bg-zt-more opacity-10 min-w-[84px] h-[28px] rounded-zt"></div>
			<div class="bg-zt-more opacity-10 min-w-[76px] h-[28px] rounded-zt"></div>
			<div class="bg-zt-more opacity-10 min-w-[115px] h-[28px] rounded-zt"></div>
		</div>
		<div class="flex flex-row bg-zt-normal border-[1px] border-zt-light py-2.5 px-2 overflow-hidden">
			<div class="bg-zt-more opacity-10 min-w-[117px] h-[28px] rounded-l"></div>
			<div class="bg-zt-more opacity-10 min-w-[95px] h-[28px]"></div>
			<div class="bg-zt-more opacity-10 min-w-[117px] h-[28px] rounded-r"></div>
		</div>
		<div class="h-[30px] bg-[#2E3C4F] text-[11px] border-x border-zt-light font-medium flex items-center justify-between pl-[10px] uppercase">
			<div class="text-ellipsis h-full flex items-center z-10 mr-1 break-all gap-x-6 line-clamp-1 capitalize !w-[135px]">
				<span class="cursor-pointer uppercase underline zt-hover">L.p</span>
				<span class="cursor-pointer uppercase underline zt-hover">Drużyna</span>
			</div>
			<div class="flex">
				<div class="foot-tab-row-item"><div>M</div></div>
				<div class="foot-tab-row-item"><div>BZ</div></div>
				<div class="foot-tab-row-item"><div>BS</div></div>
				<div class="foot-tab-row-item"><div>RB</div></div>
				<div class="foot-tab-row-item"><div>P</div></div>
			</div>
		</div>
		<div v-for="i in 20" class="flex items-center justify-between pl-[10px] h-[38px] bg-[#283344] border-x border-b-[1px] border-zt-light">
			<div class="h-full flex items-center z-10 mr-1 gap-x-6 line-clamp-1 capitalize !w-[135px]">
				<span class="w-5 h-5 bg-zt-more opacity-10 rounded-zt"></span>
				<span class="w-[80px] h-5 bg-zt-more opacity-10 rounded-zt"></span>
			</div>
			<div class="flex">
				<div class="foot-tab-row-item"><div class="w-5 h-5 bg-zt-more opacity-10 rounded-zt"></div></div>
				<div class="foot-tab-row-item"><div class="w-5 h-5 bg-zt-more opacity-10 rounded-zt"></div></div>
				<div class="foot-tab-row-item"><div class="w-5 h-5 bg-zt-more opacity-10 rounded-zt"></div></div>
				<div class="foot-tab-row-item"><div class="w-5 h-5 bg-zt-more opacity-10 rounded-zt"></div></div>
				<div class="foot-tab-row-item"><div class="w-5 h-5 bg-zt-more opacity-10 rounded-zt"></div></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TablePlaceholder'
}
</script>